'use strict';

import { findLanguageByTrack } from './lib/findLanguageByTrack.js';
import { responseProcessor } from './lib/responseProcessor';

var Vendor = require('mggp-player').Vendor;
var AddonError = require('mggp-player').AddonError;
var MggpPluginBuffering = require('mggp-plugin-buffering');
// var shaka = window.shaka || require('shaka-player/dist/shaka-player.compiled.debug.js');
var shaka = window.shaka || require('shaka-player');

export default MggpVendorDash;

import CustomLoader from './loader/customLoader';
import {
  ROBUSTNESS_LEVEL,
  checkRobustness,
  isHasSrc,
  isRudeTimestamp,
  resetSrc
} from './lib/utils.js';

let robustnessAfterVideoError;

/**
 * @class MggpVendorDash
 */
function MggpVendorDash(pPlayer, pConfig) {
  Vendor.apply(this, arguments);

  var DRM_PLAYREADY = 'com.microsoft.playready';
  var DRM_MODULAR = 'com.widevine.alpha';
  var MEGOGO_DRM_PROVIDER_HOST = 'https://drm-ls.megogo.net';
  var BIN_CERTIFICATE_URL = MEGOGO_DRM_PROVIDER_HOST + '/cenc/getlicense/cert.bin';

  var self = this;
  var pluginBuffering;

  if (self.player.get('player:usePluginBuffering')) {
    pluginBuffering = new MggpPluginBuffering(pPlayer, pConfig);
  }

  var _customLoader = new CustomLoader(this);
  var _src = null;
  var _videoInfo = null;
  var _video = null;
  var _startPosition = 0;
  var _started = false;
  var _paused = false;
  var _beforeCompleteFired = false;
  // var _lastPlayPos = 0;
  var _autoplay = true;
  var _shakaPlayer = null;
  var _qualityToSwitch = void 0;
  var _audioToSwitch = void 0;
  var _availableBitrates;
  var _isBuffering = false;
  var _certificateData = null;
  var _certificateXHR = null;
  var _currentLanguage = '';
  var _manifest = null;
  var _liveStartTime = 0;
  var _disposed = false;
  let videoRobustness;

  self.player.set('shaka', shaka);
  // var HttpPlugin = require('../src/loader/http-plugin');

  this.dispose = function () {
    _disposed = true;
    toggleEvents(false);

    var returnedPromise;
    if (_shakaPlayer) {
      returnedPromise = _shakaPlayer.unload();
      _shakaPlayer = null;
    }
    if (!self.player.config['singleVideoInstance'] && _video && _video.parentNode) {
      if (_video && _video.parentNode) _video.parentNode.removeChild(_video);
      _video = null;
    } else {
      _video.pause();
      resetSrc(_video);
      _video.load();
    }

    _src = null;
    _videoInfo = null;
    _certificateData = null;
    _qualityToSwitch = void 0;
    _audioToSwitch = void 0;
    _started = false;
    _availableBitrates = void 0;
    _isBuffering = false;

    if (_certificateXHR && _certificateXHR.readyState !== 4) { // MHP-710
      _certificateXHR.abort();
    }

    // self.player = null;
    // self.namespase = null;
    // self.config = null;

    if (pluginBuffering) {
      pluginBuffering.dispose();
    }

    return returnedPromise;
  };

  this.load = async function (pSrc, pVideoInfo, pOptions) {
    if (!pVideoInfo && _disposed) return;

    if (self.config.supportedDrmType === 'fairplay') return; //MADV-1194

    if (!_certificateData
      && pVideoInfo['license_server']
      && pVideoInfo['license_server'].indexOf(MEGOGO_DRM_PROVIDER_HOST) !== -1) { //MHP-1788
      loadBinCertificate(pSrc, pVideoInfo, pOptions);
      return;
    }

    if (robustnessAfterVideoError) {
      videoRobustness = robustnessAfterVideoError;
    } else {
      videoRobustness = await checkRobustness();
    }


    if (pOptions) {
      _qualityToSwitch = 'defaultQuality' in pOptions ? pOptions['defaultQuality'] : -1;
      self.checkOptions(pOptions);
    } else {
      pOptions = {};
    }
    setState(5);
    _videoInfo = pVideoInfo || null;
    _src = pSrc || pVideoInfo.src || null;
    _liveStartTime = 0;

    if ('defaultSubtitles' in pOptions) {
      self.setSubtitles(pOptions['defaultSubtitles']);
    }

    if ('autoplay' in pOptions) {
      _autoplay = pOptions.autoplay;
    }

    if (!_videoInfo && !_src) {
      self.emit('player:mediaError', { message: 'Src not found' });
      return;
    }

    _disposed = false;

    if (!_video) {
      createPlayer();
    }

    toggleEvents(true);
    onQualityList({ data: self.player.get('qualityList') });

    if (_videoInfo['drm_type'] !== "") {
      var protectionData = {};
      var serverCertificates = {};
      if ('license_server' in _videoInfo) {
        if (_videoInfo['drm_type'] === 'modular') {
          protectionData[DRM_MODULAR] = _videoInfo['license_server'];
          serverCertificates[DRM_MODULAR] = {
            serverCertificate: _certificateData,
          };
        } else if (_videoInfo['drm_type'] === 'playready') {
          protectionData[DRM_PLAYREADY] = _videoInfo['license_server'];
          serverCertificates[DRM_PLAYREADY] = {
            serverCertificate: _certificateData
          };
        }
      } else if (_videoInfo['wvls']) {
        for (var serverName in _videoInfo['wvls']) {
          protectionData[serverName] = _videoInfo['wvls'][serverName];
          serverCertificates[serverName] = {
            serverCertificate: _certificateData
          };
        }
      }

      var browser = self.config && self.config.device && self.config.device.browser ? self.config.device.browser.name : '';

      if (browser === 'Edge' || !_certificateData) {
        _shakaPlayer.configure({
          drm: {
            servers: protectionData
          }
        });
      } else {
        _shakaPlayer.configure({
          drm: {
            servers: protectionData,
            advanced: serverCertificates
          }
        });
      }
    }

    setVideoVolume(self.get('volume') / 100);

    if (self.get('muted')) {
      _video.muted = true;
    }

    if ('startSeconds' in pOptions) {
      _startPosition = parseInt(pOptions['startSeconds']);
    } else {
      _startPosition = 0;
    }

    var contentType = _videoInfo['content_type'];

    // maybe need to remove this checks for 'live' content
    // but the effect of this removal is unknown
    // so let it be
    if (
      [ "tv_dvr", "live_dvr", "m_ch" ].includes(contentType) &&
      !isRudeTimestamp(_startPosition) // if startPosition is not a timestamp, reset it
    ) {
      _startPosition = undefined;
    } else if (contentType === "tv_linear") {
      _startPosition = undefined;
    }

    if (_audioToSwitch === undefined) {
      var audioTracks = self.player.get('audioTrackList');
      if (audioTracks && audioTracks.length > 0) {
        onAudioTrackListChanged({ data: audioTracks });
      } else {
        self.player.on('property:audioTrackList', onAudioTrackListChanged);
      }
    }

    if (_disposed || !_src) {
      return;
    }

    _shakaPlayer.load(_src, _startPosition).catch(onShakaPlayerError);
  };

  this.play = function () {
    if (!_disposed && _video && isHasSrc(_video)) _video.play();
  };

  this.pause = function () {
    if (_video && !_paused) {
      _paused = true;
      _video.pause();
    }
  };

  this.stop = function () {
    if (_video) {
      resetSrc(_video);
      if (self.player.config['singleVideoInstance'] == true) {
        _video.style.display = 'none';
      } else {
        self.container.removeChild(_video);
      }

    }

    return this.dispose();
  };

  this.togglePlayPause = function () {
    if (_video) {
      self.get('state') == 1 ? this.pause() : this.play();
    }
  };

  this.seekTo = function (seconds) {
    if (typeof seconds !== 'number' || Number.isNaN(seconds)) {
      self.log('seekTo: argument "seconds" has invalid value:', seconds);
      return;
    }
    if (seconds < 0) {
      seconds = 0;
    }
    setState(5);
    self.set('position', seconds);
    _video.currentTime = seconds;
  };

  this.setVolume = function (pVolume) {
    if (pVolume > 100) {
      pVolume = 100;
    } else if (pVolume < 0) {
      pVolume = 0;
    }
    // if (self.get('muted')) {
    //   _volumeBeforeMuted = pVolume / 100;
    //   self.unMute();
    // }
    if (_video) {
      setVideoVolume(pVolume / 100);
      // _video.volume = pVolume / 100;
    }
    self.set('volume', pVolume);
  };

  this.mute = function () {
    if (self.get('muted')) return;
    self.set('muted', true);
    _video.muted = true;
  };

  this.unMute = function () {
    if (!self.get('muted')) return;
    self.set('muted', false);
    _video.muted = false;
  };

  this.getPlayableElement = function () {
    return _video;
  };

  this.setQuality = function (bitrate) {
    try {
      bitrate = parseInt(bitrate);
    } catch (error) {
      bitrate = -1;
    }
    if (!_shakaPlayer) {
      _qualityToSwitch = bitrate;
      return;
    }

    if (bitrate === -1) {
      _shakaPlayer.configure({
        abr: {
          enabled: true,
        }
      });
      onAdaptationEvent();
    } else {
      var audioLanguages = _shakaPlayer.getAudioLanguages();
      var allTracks = _shakaPlayer.getVariantTracks().filter(function (track) {
        var result = false;
        if (audioLanguages && audioLanguages.length > 0) {
          if (!_currentLanguage) {
            _currentLanguage = audioLanguages[0];
          }
          result = track.language === _currentLanguage;
        } else {
          result = true;
        }
        return result;
      });
      var track = getVideoTrackByBitrate(allTracks, bitrate);
      if (track) {
        _shakaPlayer.configure({
          abr: {
            enabled: false
          }
        });
        _shakaPlayer.selectVariantTrack(track, true);
      } else {
        _shakaPlayer.configure({
          abr: {
            enabled: true,
          }
        });
        bitrate = -1;
      }
    }
    self.player.set('quality', bitrate);
  };

  this.setAudioTrack = function (id) {
    if (!_shakaPlayer) {
      _audioToSwitch = id;
      return;
    }

    var audioLanguages = _shakaPlayer.getAudioLanguages();

    if (audioLanguages.length === 0) {
      _audioToSwitch = id;
      return;
    }

    if (audioLanguages.length === 1) {
      _currentLanguage = audioLanguages[0];
      return;
    }
    const audioTracks = self.player.get('audioTrackList') || [];
    const byMatching = (track) => [ track.id, track.lang, track.lang_iso_639_1 ].includes(id);
    const audioTrack = audioTracks.find(byMatching) || audioTracks[0];

    if (!audioTrack) {
      return;
    }

    const audioLanguage = findLanguageByTrack(audioTrack)(audioLanguages);

    if (audioLanguage) {
      self.player.set('audioTrack', audioTrack.id);
      _shakaPlayer.configure({
        preferredAudioLanguage: audioLanguage,
      });
      _shakaPlayer.selectAudioLanguage(audioLanguage);
      _currentLanguage = audioLanguage;
      self.setQuality(self.player.get('quality'));
    }
  };

  this.onManifestPlayList = function (pManifest) {
    _manifest = pManifest;
  };

  function loadBinCertificate(pSrc, pVideoInfo, pOptions) {
    try {
      _certificateXHR = new XMLHttpRequest();
      _certificateXHR.responseType = 'arraybuffer';
      _certificateXHR.open('GET', BIN_CERTIFICATE_URL, true);
      _certificateXHR.onreadystatechange = function () {
        if (_certificateXHR.readyState === 4) {
          if (_certificateXHR.status === 200 && _certificateXHR.response) {
            _certificateData = new Uint8Array(_certificateXHR.response);
            self.load(pSrc, pVideoInfo, pOptions);
          } else {
            tryPlayWithEmptyCert(pSrc, pVideoInfo, pOptions);
          }
          _certificateXHR = null;
        }
      };
      _certificateXHR.send(null);
    } catch (e) {
      tryPlayWithEmptyCert(pSrc, pVideoInfo, pOptions);
    }

    function tryPlayWithEmptyCert(pSrc, pVideoInfo, pOptions) {
      _certificateData = new Uint8Array(0);
      self.load(pSrc, pVideoInfo, pOptions);
    }
  }

  function createPlayer() {

    if (self.player.config['singleVideoInstance'] == true) {
      _video = self.player.get(self.namespace + 'video');
    }

    if (_video) {
      _video.style.display = 'inline-block';
    } else {
      _video = document.createElement('video');
      self.container.appendChild(_video);
    }


    _video.className = self.namespace + 'video';
    _video.style.width = "100%";
    _video.style.height = "100%";
    // when a large gap appeared, shaka has the strange condition at gap_jumping_controller.js:159
    // to go through this condition set autoplay to true
    _video.autoplay = true;

    shaka.polyfill.installAll();
    if (shaka.Player.isBrowserSupported()) {
      _shakaPlayer = new shaka.Player(_video);
      _shakaPlayer.configure({
        abr: {
          enabled: true,
          restrictions: {
            maxHeight: 800
          }
        },
        manifest: {
          dash: { // MHP-1943 (Test 1_1)
            initialSegmentLimit: Math.round((7 * 24 * 60 * 60 / 4)), // 7 day / 4 sec chunk
            clockSyncUri: 'https://time.akamai.com/?ms&iso',
          },
        },
        mediaSource: {
          forceTransmux: true
        },
        streaming: {
          inaccurateManifestTolerance: 15,
          // startAtSegmentBoundary was 'true' from task MHP-1561, this means that stream should start from the start of the segment
          // or at 7 days ago and this is wrong. It worked somehow, because in onTimeUpdate there was a seek to availableSeekRange.end
          // and this produced a race between shaka initialization and onTimeUpdate call
          // so explicitly revert it to false (default)
          startAtSegmentBoundary: false,
          //jumpLargeGaps: true,
        },
        drm: {
          defaultVideoRobustnessForWidevine: videoRobustness,
        }

      });
    } else {
      self.emit('error');
    }

    if (pluginBuffering) {
      pluginBuffering.setVideo(_video);
    }

    window.shaka = _shakaPlayer;
    _shakaPlayer.getNetworkingEngine().registerResponseFilter(responseProcessor);
  }

  function setState(pNewState) {
    self.set('state', pNewState);
    self.emit('stateChange', pNewState);

    if (pNewState === 1) {
      setTimeout(onStreamingChanged, self.player.get("isMobile") ? 1000 : 0);
      if (_audioToSwitch !== undefined) {
        self.setAudioTrack(_audioToSwitch);
        _audioToSwitch = undefined;
      }

      if (_qualityToSwitch !== undefined) {
        self.setQuality(_qualityToSwitch);
        _qualityToSwitch = undefined;
      }
    }
  }

  function toggleEvents(pOn) {
    if (pOn) {
      if (_video) {
        _video.addEventListener("loadstart", onVideoLoadStart);
        _video.addEventListener("canplay", onVideoCanPlay);
        _video.addEventListener("pause", onVideoPause);
        _video.addEventListener("playing", onVideoPlaying);
        _video.addEventListener("seeked", onVideoSeeked);
        _video.addEventListener("seeking", onVideoSeeking);
        _video.addEventListener("volumechange", onVideoVolumeChange);
        _video.addEventListener("durationchange", onVideoDurationChange);
        _video.addEventListener("ended", onVideoEnded);
        _video.addEventListener("error", onVideoError);
      }

      if (_shakaPlayer) {
        _shakaPlayer.addEventListener('error', onShakaPlayerError);
        _shakaPlayer.addEventListener('adaptation', onAdaptationEvent);
        _shakaPlayer.addEventListener('buffering', onBufferingEvent);
        _shakaPlayer.addEventListener('trackschanged', onTracksChanged);
        // _shakaPlayer.addEventListener('streaming', onStreamingChanged);
        // _shakaPlayer.addEventListener('onstatechange', onShakaStateChanged);
      }

      if (self.player && self.player.on) {
        self.player.on("player:timeUpdate", onTimeUpdate);
        self.player.on('property:qualityList', onQualityList);
      }
    } else {
      if (_video) {
        _video.removeEventListener("loadstart", onVideoLoadStart);
        _video.removeEventListener("canplay", onVideoCanPlay);
        _video.removeEventListener("pause", onVideoPause);
        _video.removeEventListener("playing", onVideoPlaying);
        _video.removeEventListener("seeked", onVideoSeeked);
        _video.removeEventListener("seeking", onVideoSeeking);
        _video.removeEventListener("volumechange", onVideoVolumeChange);
        _video.removeEventListener("durationchange", onVideoDurationChange);
        _video.removeEventListener("ended", onVideoEnded);
        _video.removeEventListener("error", onVideoError);
      }

      if (_shakaPlayer) {
        _shakaPlayer.removeEventListener('error', onShakaPlayerError);
        _shakaPlayer.removeEventListener('adaptation', onAdaptationEvent);
        _shakaPlayer.removeEventListener('buffering', onBufferingEvent);
        _shakaPlayer.removeEventListener('trackschanged', onTracksChanged);
        // _shakaPlayer.removeEventListener('streaming', onStreamingChanged);
        // _shakaPlayer.removeEventListener('onstatechange', onShakaStateChanged);
      }

      if (self.player && self.player.off) {
        self.player.off("player:timeUpdate", onTimeUpdate);
        self.player.off('property:qualityList', onQualityList);
      }
    }
  }

  function setVideoVolume(volume) {
    _video.removeEventListener("volumechange", onVideoVolumeChange);
    _video.volume = volume;
    setTimeout(function () {
      if (_video) {
        _video.addEventListener("volumechange", onVideoVolumeChange);
      }
    }, 0);
  }

  function onVideoError() {
    const isReloading = tryToReloadStreamByRobustness();
    if (!isReloading) {
      self.emit("mediaError", { fatal: true });
      setState(5);
    }
  }

  function onVideoLoadStart() {
    setState(3);
  }

  function onVideoCanPlay() {
    if (!_disposed && !_started) {
      if (_autoplay) {
        _video && _video.play();
      }
      self.emit("mediaCanPlay");
      _shakaPlayer.configure({
        abr: {
          restrictions: undefined
        }
      });
    }
  }

  function onVideoPause() {
    if (_paused) {
      setState(2);
    } else if (_video.paused) {
      setState(_isBuffering ? 3 : 5);
    }
  }

  function onVideoPlaying() {
    if (!_started && _video) {
      var tracks = _video.textTracks;
      if (tracks && tracks.length > 0) {
        for (var i = 0, l = tracks.length; i < l; ++i) {
          if (tracks[i].kind === 'subtitles') {
            tracks[i].mode = 'disabled';
          }
        }
      }

    }

    _started = true;
    _paused = false;
    setState(1);
  }

  function onVideoSeeked() {
    self.emit("mediaSeekEnd");
  }

  function onVideoSeeking() {
    self.emit("mediaSeekStart");
    setState(4);
  }

  function onVideoVolumeChange(event) {
    if (self.player.get('muted') !== event.currentTarget.muted) {
      self[event.currentTarget.muted ? 'mute' : 'unMute']();
    } else {
      self.set('volume', _video.volume * 100);
    }
  }

  function onVideoDurationChange() {
    self.set('duration', _video.duration);
  }

  function onTimeUpdate() {
    if (_shakaPlayer.isLive() && _liveStartTime === 0) {
      // I just leave this commented for future use or understanding what is going on here

      // var availableSeekRange = _shakaPlayer.seekRange();
      // if (!_startPosition) {
      // console.log('!!!!!!!!!!!!end', getTime(availableSeekRange.end), 'current 1', getTime(_video.currentTime));

      // _video.currentTime = availableSeekRange.end;
      // instead of 'availableSeekRange.end' could use '_shakaPlayer.goToLive();'
      // }
      _liveStartTime = _video.currentTime;
    }
    if (_video.currentTime - _liveStartTime !== self.get('position')) {
      self.set('position', _video.currentTime - _liveStartTime);

      var state = self.get('state');

      if ((state >= 3) &&
        !_video.paused &&
        !_video.ended &&
        !_video.seeking &&
        _video.currentTime > 1 &&
        !_paused &&
        !_isBuffering
      ) {
        setState(1);
      }
    }


    if (self.get('duration') > 0 && self.get('duration') - self.get('position') < 1 && !_beforeCompleteFired) {
      _beforeCompleteFired = true;
      self.emit("mediaBeforeComplete");
    }

    for (var i = 0; i < _video.buffered.length; i++) {
      if (_video.buffered.start(i) <= self.get('position') && _video.buffered.end(i) > self.get('position')) {
        self.set('loadedFraction', _video.buffered.end(i) / self.get('duration'));
        break;
      }
    }

    if (Math.abs(_video.duration - _video.currentTime) <= 0.001) {
      onVideoEnded();
    }
  }

  function onQualityList(event) {
    _availableBitrates = event.data;
  }

  function onVideoEnded() {
    toggleEvents(false);
    setState(0);
    _started = false;
  }

  function findNameFromManifest(tracks) {
    if (_manifest && _manifest.playlists) {
      _manifest.playlists.forEach(function (playlist) {
        var attributes = playlist.attributes;
        var resolution = attributes['RESOLUTION'];
        if (resolution) {
          tracks.forEach(function (track) {
            if (track.width === resolution.width && track.height === resolution.height) {
              track.representationVideoId = attributes['NAME'];
            }
          });
        }
      });
    }
  }

  // function onShakaStateChanged (event) {
  //   console.log(event);
  // }

  function onStreamingChanged(event) {
    var qualities = self.player.get('qualityList');
    var audioLanguages = _shakaPlayer.getAudioLanguages();
    var firstAudio = "";

    if (audioLanguages.length >= 1) {
      firstAudio = audioLanguages[0];
    }
    var tracks = _shakaPlayer.getVariantTracks().filter(function (track) {
      return track.language === firstAudio;
    });

    //MHP-2044 Validation quality stream vs manifest
    if (tracks.length && qualities.length !== tracks.length + 1) {
      findNameFromManifest(tracks);
      var valid = [];
      var autoQuality = qualities.find(function (quality) {
        return quality.index === -1;
      });
      tracks.forEach(function (track) {
        var quality = getQualityByVideoTrack(qualities, track);
        if (quality) valid.push(quality);
      });
      if (valid.length === tracks.length) {
        valid.sort(function (a, b) {
          return a.bitrate - b.bitrate;
        }).reverse();
        if (autoQuality) valid = [ autoQuality ].concat(valid);
        self.player.set("qualityList", valid);

        //Check quality after validation
        var currentSelectedQuality = valid.find(function (quality) {
          return quality.bitrate === self.player.get("quality");
        });
        // if current quality in player not actual drop to auto
        if (!currentSelectedQuality) {
          if (_qualityToSwitch !== undefined) _qualityToSwitch = -1;
          var options = self.player.get("vendorOptions");
          if (options.defaultQuality) options.defaultQuality = -1;
          self.setQuality(autoQuality.index);
        }
      }
    }
  }

  function onAdaptationEvent(event) {
    var config = _shakaPlayer.getConfiguration();
    var qualities = self.player.get('qualityList');
    var tracks = _shakaPlayer.getVariantTracks().filter(function (track) {
      return track.language === _currentLanguage;
    });

    if (config && config.abr && config.abr.enabled) {
      findNameFromManifest(tracks);
      var activeTrack;
      for (var i = 0, l = tracks.length; i < l; ++i) {
        if (tracks[i].active) {
          activeTrack = tracks[i];
          break;
        }
      }
      if (activeTrack && qualities) {
        var quality = getQualityByVideoTrack(qualities, activeTrack);
        if (quality) {
          self.emit('autoQualitySwitch', quality.index);
        }
      }
    }

  }

  function onBufferingEvent(event) {
    if (event.buffering) {
      var bufferTime = getBufferTime();
      if (!_paused && bufferTime <= 1 && _video.currentTime > 0) {
        _isBuffering = true;
        self.emit('buffering', { isBuffering: true, timestamp: new Date().getTime(), isSeeking: _video.seeking });
      }
      setState(3);
    } else {
      if (_isBuffering) {
        _isBuffering = false;
        self.emit('buffering', { isBuffering: false, timestamp: new Date().getTime(), isSeeking: _video.seeking });
      }

      if (_started) {
        if (_paused) {
          setState(2);
        } else {
          setState(1);
        }
      }
    }
  }

  function onTracksChanged(event) {
    /*if (_audioToSwitch !== undefined) {
      self.setAudioTrack(_audioToSwitch);
      _audioToSwitch = void 0;
    }

    if (_qualityToSwitch !== undefined) {
      self.setQuality(_qualityToSwitch);
      _qualityToSwitch = void 0;
    }*/

    if (!self.player.get("isMobile")) onStreamingChanged();
  }


  function onAudioTrackListChanged(event) {
    if (!self.player) return;
    self.player.off('property:audioTrackList', onAudioTrackListChanged);
    if (event.data && event.data.length > 0) {
      self.setAudioTrack(event.data[0].id);
    }
  }

  function onShakaPlayerError(event) {
    if (_disposed) return;
    // self.emit("mediaError", {fatal: true});
    // setState(5);

    var errorType = '';
    var errorCode = '';
    var errorMessage;
    try {
      if (event.detail) {
        errorMessage = 'event.category: ' + event.detail.category + '\nevent.code: ' + event.detail.code + '\nevent.data: ' + event.detail.data.toString();
      } else {
        errorMessage = 'event.category: ' + event.category + '\nevent.code: ' + event.code + '\nevent.data: ' + event.data.toString();
      }
    } catch (error) {
      errorMessage = '';
    }
    var isFatal = false;
    var category = event.detail ? event.detail.category : event.category;

    for (var prop in shaka.util.Error.Category) {
      if (shaka.util.Error.Category[prop] === category) {
        errorType = prop;
      }
    }
    for (prop in shaka.util.Error.Code) {
      if (shaka.util.Error.Code[prop] === event.code) {
        errorCode = prop;
      }
    }
    switch (category) {
      case 1:
      case 4:
        isFatal = event.code !== 4032;
        break;
      case 5:
      case 6:
      case 7: {
        const isReloading = tryToReloadStreamByRobustness();
        if (isReloading) {
          return;
        }
        isFatal = event.code !== 6003;
        // event.code: 6003
        // event.data: Failed to execute 'setMediaKeys' on 'HTMLMediaElement': The existing ContentDecryptionModule object cannot be removed at this time.
        if (!isFatal) self.load(self.player.get('src'), self.player.get('videoInfo'), self.player.get('vendorOptions'));
        if (event.code === 7000) isFatal = false; //mediaFileIsNotSupported->Unable to play file. Format is not supported
        break;
      }
      case 2:
      case 3: {
        const isReloading = tryToReloadStreamByRobustness({
          errorCode,
          errorMessage,
          errorType,
        });
        if (isReloading) {
          return;
        }
        //MHP-2044: PIPELINE_ERROR_DECODE означает что без перезагрузки браузера видео скорее всего не запустится
        _video.pause();
        resetSrc(_video);
        _video.load();
        _shakaPlayer.destroy().then(function (){
          new AddonError(self.player, errorType, errorCode, errorMessage, true);
        }).catch(function (e) {
          new AddonError(self.player, errorType, errorCode, errorMessage, true);
        });
        return;
      }
      case 8:
      case 9:
        isFatal = false;
        break;
    }

    new AddonError(self.player, errorType, errorCode, errorMessage, isFatal);
  }

  function tryToReloadStreamByRobustness(errorData) {
    if (!robustnessAfterVideoError) {
      robustnessAfterVideoError = ROBUSTNESS_LEVEL.SW_SECURE_CRYPTO;
      _shakaPlayer.destroy().then(function (){
        _video.pause();
        resetSrc(_video);
        _video.load();
        _video = null;
        _shakaPlayer = null;
        self.load(self.player.get('src'), self.player.get('videoInfo'), self.player.get('vendorOptions'));
      }).catch(function (e) {
        if (errorData) {
          new AddonError(self.player, errorData.errorType, errorData.errorCode, errorData.errorMessage, true);
        }
      });
      return true;
    }
    return false;
  }

  function getVideoTrackByBitrate(tracks, bitrate) {
    findNameFromManifest(tracks);
    var result = null, foundBitrate;
    for (var i = 0, l = tracks.length; i < l; ++i) {
      var videoId = tracks[i].originalVideoId || tracks[i].representationVideoId;
      if (videoId) {
        try {
          foundBitrate = parseInt(videoId);
        } catch (error) {
          // no op
        }
      } else {
        foundBitrate = getBitrate(tracks[i].videoBandwidth);
      }
      if (bitrate === foundBitrate) {

        result = tracks[i];
        break;
      }
    }

    return result;
  }

  function getQualityByVideoTrack(qualities, track) {
    var result = null, bitrate;
    var videoId = track.originalVideoId || track.representationVideoId;
    if (videoId) {
      try {
        bitrate = parseInt(videoId);
      } catch (error) {
        // no op
      }
    }
    if (!bitrate) {
      bitrate = getBitrate(track.videoBandwidth);
    }
    for (var i = 0, l = qualities.length; i < l; ++i) {
      if (qualities[i].bitrate == bitrate) {
        result = qualities[i];
        break;
      }
    }
    return result;
  }

  function getBitrate(bandwidth) {
    var bitrate = bandwidth / 1000;

    if (bitrate > 300 && bitrate < 700) {
      bitrate = 240;
    }
    if (bitrate >= 700 && bitrate < 950) {
      bitrate = 320;
    }
    if (bitrate >= 950 && bitrate < 1350) {
      bitrate = findBitrate(360, 404);
    }
    if (bitrate >= 1350 && bitrate < 1550) {
      bitrate = 480;
    }
    if (bitrate >= 1550 && bitrate < 3500) {
      bitrate = findBitrate(576, 720);
    }
    if (bitrate >= 3500) {
      bitrate = 1080;
    }
    return bitrate;
  }

  function findBitrate(b1, b2) {
    var result = 0;
    if (_availableBitrates) {
      for (var i = 0, l = _availableBitrates.length; i < l; ++i) {
        if (_availableBitrates[i].bitrate == b1 || _availableBitrates[i].bitrate == b2) {
          result = _availableBitrates[i].bitrate;
          break;
        }
      }
    }
    return result;
  }

  function getBufferTime() {
    var result = -1;
    var video = self.player.getPlayableElement();
    if (video && video.buffered && video.buffered.length > 0) {
      var i = video.buffered.length;
      var pos = self.player.get('position');
      while (i--) {
        if (video.buffered.start(i) <= pos && video.buffered.end(i) >= pos) {
          result = video.buffered.end(i) - pos;
        }
      }
    }
    return result;
  }

  self.log('MggpVendorDash:Created!');
}



MggpVendorDash.prototype = Object.create(Vendor.prototype);
MggpVendorDash.prototype.constructor = MggpVendorDash;

MggpVendorDash.canPlay = function (pType, pConfig) {
  return true;
};

MggpVendorDash.priority = 0;
MggpVendorDash.mimeTypes = [ "mpd" ];

